// extracted by mini-css-extract-plugin
export default {"root":"styles_root__oQtYX","red":"styles_red__OsxpK","green":"styles_green__4AiAf","gray":"styles_gray__HLf2q"};